<template>
    <div class="page-dashboard-info-form">
        <div class="page-dashboard-info-form__item" v-if="user && user.discount">
            <div class="page-dashboard-info-form__title">
                Ваша скидка по программе лояльности
            </div>
            <div style="margin-bottom: 20px">{{user.discount}}%</div>
            <div style="margin-bottom: 20px">
                Узнать условия применения накопительной или персональной скидки вы можете
                <a href="https://pyeoptics.com/pages/loyalty-programm/" target="_blank">здесь</a>.
                Если у вас остались вопросы,
                напишите в <a href="#chatra_trigger">чат.</a>
            </div>
            <div>
                * Скидка обновляется через сутки после завершения покупки.
            </div>
        </div>
        <div class="page-dashboard-info-form__item">
            <page-dashboard-info-form-data />
        </div>
        <div class="page-dashboard-info-form__item">
            <page-dashboard-info-form-info />
        </div>
        <div class="page-dashboard-info-form__consent">
                Внося изменения, вы соглашаетесь с <a v-bind:href="urls.oferta" target="_blank">условиями публичной оферты</a> и <a
            v-bind:href="urls.policy" target="_blank">политикой обработки персональных данных</a> и даёте <a
            v-bind:href="urls.consent" target="_blank">согласие на обработку персональных данных</a>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import config from '~/config';

export default {
    name: 'page-dashboard-info-user',
    data: () => ({
        urls: {
            oferta: config.urls.oferta,
            policy: config.urls.policy,
            consent: config.urls.consent,
        },
    }),
    computed: {
        ...mapState('user', [
            'user',
        ]),
    },
    mounted() {
        this.$store.dispatch('user/getUserInfo');
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-dashboard-info-form {
    padding: 0 20px;
    &__item {
        & ~ & {
            margin-top: 40px;
        }
    }
    &__title {
        margin-bottom: 20px;

        text-transform: uppercase;
    }
    &__consent {
        margin-top: 32px;
    }
}
</style>
